// eslint-disable-next-line import/no-unresolved
import Keycloak from 'keycloak-js';
import processError from '../../../utils/processError';
import { authorizedLoginFailed, authorizedLoginSuccessful, refreshKeyCloak } from '../actions';
import { KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL } from '../../../configs';

export default function* initKeyCloak() {
  try {
    if (window.keycloak) {
      return;
    }
    const { dispatch } = window.appStore;
    window.keycloak = new Keycloak({
      url: KEYCLOAK_URL || '',
      realm: KEYCLOAK_REALM || '',
      clientId: KEYCLOAK_CLIENT_ID || '',
    });
    window.keycloak.onTokenExpired = () => {
      dispatch(refreshKeyCloak());
    };
    window.keycloak.onAuthSuccess = async () => {
      const profile = await window.keycloak.loadUserProfile();
      const { token } = window.keycloak;
      dispatch(authorizedLoginSuccessful({ profile, token }));
    };
    window.keycloak.onAuthError = () => {
      dispatch(authorizedLoginFailed());
    };
    window.keycloak.onAuthLogout = () => {
      dispatch(authorizedLoginFailed());
    };
    yield window.keycloak.init({
      onLoad: 'check-sso',
      // enableLogging: true,
      // checkLoginIframe: false,
    });
  } catch (e) {
    yield processError(e);
  }
}
